__turbopack_context__.v({
  "body": "SnackbarContainer-module-scss-module__afiWiq__body",
  "bottom-left": "SnackbarContainer-module-scss-module__afiWiq__bottom-left",
  "colored": "SnackbarContainer-module-scss-module__afiWiq__colored",
  "container": "SnackbarContainer-module-scss-module__afiWiq__container",
  "dark": "SnackbarContainer-module-scss-module__afiWiq__dark",
  "light": "SnackbarContainer-module-scss-module__afiWiq__light",
  "progress-bar": "SnackbarContainer-module-scss-module__afiWiq__progress-bar",
  "toast": "SnackbarContainer-module-scss-module__afiWiq__toast",
});
